import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../services/auth";
import LogoCompleta from "../../../assets/logonotify1.png";
import LogoIcone from "../../../assets/notifyicone.png";



const HEADER_HEIGHT = 56;

const Editarperfil = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [companyName, setCompanyName] = useState("Nome da Empresa");
  const [logoPreview, setLogoPreview] = useState(null);
  const fileInputRef = useRef(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editedCompanyName, setEditedCompanyName] = useState(companyName);
  const [changePwOpen, setChangePwOpen] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [pwError, setPwError] = useState("");
  const navigate = useNavigate();
  const [operatorName, setOperatorName] = useState("Nome do Operador");
  const [operatorPhone, setOperatorPhone] = useState("+55 (11) 98888-8888");
  const [editedOperatorName, setEditedOperatorName] = useState(operatorName);
  const [editedOperatorPhone, setEditedOperatorPhone] = useState(operatorPhone);

  const isMobile = typeof window !== 'undefined' ? window.innerWidth <= 768 : false;

  const cardStyle = {
    display: 'flex',
    gap: 20,
    alignItems: isMobile ? 'flex-start' : 'center',
    flexDirection: isMobile ? 'column' : 'row',
    background: '#fff',
    padding: isMobile ? 16 : 20,
    borderRadius: 12,
    boxShadow: '0 6px 18px rgba(0,0,0,0.08)',
  };

  const circleStyle = {
    width: isMobile ? 80 : 96,
    height: isMobile ? 80 : 96,
    borderRadius: '50%',
    background: 'linear-gradient(180deg, #f3f7f6, #ffffff)',
    border: '4px solid rgba(81,161,151,0.12)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 12px rgba(5,64,58,0.06)',
    alignSelf: isMobile ? 'center' : 'auto',
  };

  const contentWrapperStyle = {
    flex: 1,
    display: 'flex',
    alignItems: isMobile ? 'center' : 'center',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 12,
  };

  const companyBoxStyle = {
    padding: '10px 14px',
    borderRadius: 8,
    border: '1px solid #e6efee',
    background: '#fbfdfc',
    color: '#173a37',
    fontSize: 16,
    boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.03)',
    marginTop: isMobile ? 12 : 18,
    textAlign: isMobile ? 'center' : 'left',
  };

  const contactRowStyle = {
    display: 'flex',
    gap: 12,
    marginTop: isMobile ? 12 : 16,
    flexDirection: 'column',
    width: '100%',
  };

  const contactBoxStyle = {
    padding: '10px 12px',
    borderRadius: 8,
    border: '1px solid #e6efee',
    background: '#fff',
    color: '#173a37',
    fontSize: 14,
    boxShadow: '0 4px 12px rgba(0,0,0,0.04)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: isMobile ? 'space-between' : 'flex-start',
    gap: 8,
    flex: 'none',
    width: '100%',
  };

  const contactContainerStyle = {
    marginLeft: 0,
    marginTop: 12,
    width: '100%',
    padding: 0,
  };

  // calcular deslocamento para alinhar com o início do conteúdo da empresa
  const outerPadding = 24; // wrapper padding
  const innerCardPadding = isMobile ? 16 : 20; // card padding
  const circleSize = isMobile ? 80 : 96;
  const gapBetween = 20; // gap entre círculo e conteúdo
  const contactLeftOffset = outerPadding + innerCardPadding + circleSize + gapBetween;
  if (!isMobile) {
    contactContainerStyle.marginLeft = contactLeftOffset;
    const companyWidthReduction = 2 * innerCardPadding + circleSize + gapBetween;
    contactContainerStyle.width = `calc(100% - ${companyWidthReduction}px)`;
  }

  const actionsContainerStyle = {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    flexDirection: isMobile ? 'column' : 'row',
    width: isMobile ? '100%' : 'auto',
    marginTop: isMobile ? 12 : 0,
  };

  const actionButtonStyle = {
    background: '#51a197',
    color: '#fff',
    borderRadius: 8,
    padding: '10px 16px',
    fontWeight: '700',
    width: isMobile ? '100%' : 'auto',
  };

  const changePwButtonStyle = {
    borderRadius: 8,
    padding: '10px 16px',
    fontWeight: 700,
    width: isMobile ? '100%' : 'auto',
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar Bootstrap 5 */}
      <nav
        className={`d-flex flex-column flex-shrink-0 text-white${window.innerWidth <= 768 && sidebarOpen ? ' menu-aberto' : ''}`}
        style={{
          width:
            window.innerWidth <= 768
              ? sidebarOpen
                ? "80vw"
                : 56
              : sidebarOpen
                ? 220
                : 70,
          maxWidth:
            window.innerWidth <= 768
              ? sidebarOpen
                ? 260
                : 56
              : sidebarOpen
                ? 220
                : 70,
          minWidth:
            window.innerWidth <= 768
              ? 56
              : sidebarOpen
                ? 220
                : 70,
          background: "#005c53",
          minHeight: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          zIndex: window.innerWidth <= 768 && sidebarOpen ? 3000 : 1300,
          transition: "width 0.3s",
          alignItems: "center",
          boxShadow:
            window.innerWidth <= 768 && sidebarOpen
              ? "4px 0 16px rgba(0,0,0,0.18)"
              : "2px 0 8px rgba(0,0,0,0.10)",
          overflowX: "hidden",
          overflowY: "auto",
          scrollbarWidth: "thin",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: sidebarOpen ? "row" : "column",
            justifyContent: sidebarOpen ? "space-between" : "center",
            alignItems: "center",
            padding: sidebarOpen ? "16px 16px 8px 16px" : "24px 0 8px 0",
            transition: "all 0.3s",
            gap: sidebarOpen ? 12 : 8,
          }}
        >
          {sidebarOpen ? (
            <a href="/app">
              <img src={LogoCompleta} alt="Logo Completa" style={{ height: 40, transition: "all 0.3s" }} />
            </a>
          ) : (
            <a href="/app">
              <img src={LogoIcone} alt="Logo Ícone" style={{ height: 32, width: 32, transition: "all 0.3s" }} />
            </a>
          )}
          <button
            onClick={() => setSidebarOpen((open) => !open)}
            className="btn btn-link text-white"
            style={{
              fontSize: 24,
              textDecoration: "none",
              boxShadow: "none",
              marginLeft: sidebarOpen ? 12 : 0,
              marginRight: 0,
              padding: 0,
              alignSelf: "center",
            }}
            title={sidebarOpen ? "Fechar menu" : "Abrir menu"}
          >
            <i className={`bi ${sidebarOpen ? "bi-x-lg" : "bi-list"}`}></i>
          </button>
        </div>
        <ul className="nav nav-pills flex-column mb-auto w-100"
          style={{
            alignItems: sidebarOpen ? "flex-start" : "center",
            gap: sidebarOpen ? 0 : -12,
            paddingBottom: 0,
          }}>
          <li className="nav-item w-100">
            <a
              href="/app"
              className="nav-link d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
                background: "#51a197",
                color: "#fff",
                fontWeight: "bold",
                borderRadius: 8,
                transition: "background 0.3s",
              }}
            >
              <i className="bi bi-speedometer2" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12, color: "#fff" }}>Dashboard</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Campanha" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-megaphone" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Campanha</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Adicionarauto" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi-robot" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Automações</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Contas" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-person-lines-fill" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Contas</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Operacoes" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-gear" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Operações</span>}
            </a>
          </li>

          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>


          <li className="w-100">
            <a
              href="/Blacklist"
              className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}
            >
              <i className="bi-person-x" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Blacklist</span>}
            </a>
          </li>
          <li>
            <hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} />
          </li>


          <li className="w-100">
            <a
              href="/Webhook"
              className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}
            >
              <i className="bi-link-45deg" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Webhook</span>}
            </a>
          </li>
          <li>
            <hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} />
          </li>


          <li className="w-100">
            <a href="/broadcast" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-wi-fi" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Broadcasts</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>

        </ul>
      </nav>
      {/* Header fixo no topo, mas atrás do menu lateral */}
      <nav
        className="navbar navbar-expand-lg navbar-dark"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: HEADER_HEIGHT,
          background: "#005c53",
          zIndex: 1200,
          borderRadius: 0,
          marginLeft: 0,
        }}
      >
        <div style={{ marginLeft: sidebarOpen ? 220 : 70, transition: "margin-left 0.3s" }}>
          <span style={{ color: "#fff", fontWeight: "bold", fontSize: 20 }}>Editar Perfil</span>
        </div>
        <div className="ms-auto d-flex align-items-center pe-3">
          <div className="dropdown">
            <a
              href="#"
              className="nav-link d-flex align-items-center p-0"
              id="userDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ color: "#fff", cursor: "pointer" }}
            >
              <i
                className="bi bi-person-circle"
                style={{
                  fontSize: 28,
                }}
              ></i>
              <span
                className="d-none d-lg-inline ms-2"
                style={{
                  padding: "3px 5px",
                  borderRadius: 16,
                  transition: "background 0.2s",
                  display: "inline-block",
                }}
              >
                Nome do Usuário
              </span>
            </a>
            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
              <li>
                <a className="dropdown-item" href="/Editarperfil">Perfil</a>
              </li>

              <li>
                <a className="dropdown-item" href="#">Treinamentos</a>
              </li>

              <li>
                <a className="dropdown-item" href="#">Termos de uso</a>
              </li>

              <li>
                <a className="dropdown-item" href="/sign-in">Sair</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* Conteúdo da página de campanha */}
      <div style={{
        marginLeft: window.innerWidth > 768 ? (sidebarOpen ? 220 : 70) : 0,
        paddingTop: HEADER_HEIGHT,
        width: window.innerWidth > 768
          ? sidebarOpen
            ? "calc(100% - 220px)"
            : "calc(100% - 70px)"
          : "100vw",
        transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
      }}>
        {/* Conteúdo da página de perfil */}
        <div style={{ padding: 24 }}>
          <div style={{ width: isMobile ? "calc(100vw - 32px)" : 920, margin: isMobile ? "24px 16px" : "24px auto", padding: 24 }}>
            <div
              style={{
                display: "flex",
                gap: 20,
                alignItems: "center",
                background: "#fff",
                padding: 20,
                borderRadius: 12,
                boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                <div
                  onClick={() => fileInputRef.current && fileInputRef.current.click()}
                  style={{
                    width: 120,
                    height: 120,
                    borderRadius: "50%",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "linear-gradient(180deg, #f3f7f6, #ffffff)",
                    border: "4px solid rgba(81,161,151,0.12)",
                    boxShadow: "0 4px 12px rgba(5,64,58,0.06)",
                    cursor: "pointer",
                  }}
                >
                  {logoPreview ? (
                    <img src={logoPreview} alt="logo" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  ) : (
                    <div style={{ textAlign: "center", color: "#51a197" }}>
                      <i className="bi bi-camera" style={{ fontSize: 28 }}></i>
                      <div style={{ fontSize: 12, marginTop: 6 }}>Adicionar logo</div>
                    </div>
                  )}
                </div>
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const file = e.target.files && e.target.files[0];
                    if (file) {
                      const url = URL.createObjectURL(file);
                      setLogoPreview(url);
                    }
                  }}
                />
              </div>

              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, top: 200 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ color: "#005c53", fontSize: 14, fontWeight: 700 }}>Empresa</div>
                    <div style={{
                      marginTop: 18,
                      padding: "10px 14px",
                      borderRadius: 8,
                      border: "1px solid #e6efee",
                      background: "#fbfdfc",
                      color: "#173a37",
                      fontSize: 16,
                      boxShadow: "inset 0 1px 2px rgba(0,0,0,0.03)",
                    }}>
                      {companyName}
                    </div>



                    <div style={{ display: "flex", gap: 8, marginTop: 12, justifyContent: "flex-end" }}>
                      <button
                        className="btn"
                        style={{
                          background: "#51a197",
                          color: "#fff",
                          borderRadius: 8,
                          padding: "10px 16px",
                          fontWeight: "700",
                        }}
                        onClick={() => {
                          setEditedCompanyName(companyName);
                          setEditedOperatorName(operatorName);
                          setEditedOperatorPhone(operatorPhone);
                          setEditModalOpen(true);
                        }}
                      >
                        Editar a conta
                      </button>

                      <button
                        className="btn btn-outline-secondary"
                        style={{ borderRadius: 8, padding: "10px 16px", fontWeight: 700 }}
                        onClick={() => { setNewPassword(""); setPwError(""); setChangePwOpen(true); }}
                      >
                        Alterar senha
                      </button>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: 12, color: "#647374", fontSize: 13 }}>
                  Clique no círculo para enviar ou substituir a imagem.
                </div>
              </div>
            </div>

            <div style={contactContainerStyle}>
              <div style={contactRowStyle}>
                <div style={contactBoxStyle}>
                  <i className="bi bi-envelope" style={{ fontSize: 16, color: '#51a197' }}></i>
                  <div style={{ marginLeft: 8, color: '#0b3b38' }}>{"contato@empresa.com"}</div>
                </div>

                <div style={contactBoxStyle}>
                  <i className="bi bi-telephone" style={{ fontSize: 16, color: '#51a197' }}></i>
                  <div style={{ marginLeft: 8, color: '#0b3b38' }}>{"+55 (11) 99999-9999"}</div>
                </div>

                <div style={contactBoxStyle}>
                  <i className="bi bi-person-badge" style={{ fontSize: 16, color: '#51a197' }}></i>
                  <div style={{ marginLeft: 8, color: '#0b3b38' }}>{operatorName}</div>
                </div>

                <div style={contactBoxStyle}>
                  <i className="bi bi-phone" style={{ fontSize: 16, color: '#51a197' }}></i>
                  <div style={{ marginLeft: 8, color: '#0b3b38' }}>{operatorPhone}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {editModalOpen && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.35)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{ background: '#fff', borderRadius: 12, padding: 24, minWidth: 360, boxShadow: '0 8px 40px rgba(0,0,0,0.18)' }}>
              <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 12, color: '#005c53' }}>Editar empresa</div>
              <input
                type="text"
                placeholder="Nome da empresa"
                value={editedCompanyName}
                onChange={e => setEditedCompanyName(e.target.value)}
                style={{
                  width: '100%',
                  padding: 12,
                  fontSize: 16,
                  border: '1px solid #ddd',
                  borderRadius: 8,
                  outline: 'none',
                  background: 'white',
                  marginBottom: 12,
                  color: '#222',
                }}
              />
              <input
                type="text"
                placeholder="Nome do operador"
                value={editedOperatorName}
                onChange={e => setEditedOperatorName(e.target.value)}
                style={{
                  width: '100%',
                  padding: 12,
                  fontSize: 16,
                  border: '1px solid #ddd',
                  borderRadius: 8,
                  outline: 'none',
                  background: 'white',
                  marginBottom: 12,
                  color: '#222',
                }}
              />
              <input
                type="text"
                placeholder="Telefone do operador"
                value={editedOperatorPhone}
                onChange={e => setEditedOperatorPhone(e.target.value)}
                style={{
                  width: '100%',
                  padding: 12,
                  fontSize: 16,
                  border: '1px solid #ddd',
                  borderRadius: 8,
                  outline: 'none',
                  background: 'white',
                  marginBottom: 16,
                  color: '#222',
                }}
              />
              <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                <button onClick={() => { setEditModalOpen(false); setEditedCompanyName(companyName); setEditedOperatorName(operatorName); setEditedOperatorPhone(operatorPhone); }} style={{ padding: '8px 20px', borderRadius: 8, border: 'none', background: '#ccc', color: '#222', fontWeight: 500, cursor: 'pointer' }}>Cancelar</button>
                <button
                  onClick={() => {
                    if (!editedCompanyName.trim()) return;
                    setCompanyName(editedCompanyName.trim());
                    setOperatorName(editedOperatorName.trim());
                    setOperatorPhone(editedOperatorPhone.trim());
                    setEditModalOpen(false);
                  }}
                  style={{ padding: '8px 20px', borderRadius: 8, border: 'none', background: '#005c53', color: '#fff', fontWeight: 700, cursor: 'pointer' }}
                  disabled={!editedCompanyName.trim()}
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        )}
        {changePwOpen && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.35)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{ background: '#fff', borderRadius: 12, padding: 24, minWidth: 360, boxShadow: '0 8px 40px rgba(0,0,0,0.18)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                <i className="bi bi-lock-fill" style={{ color: '#51a197', fontSize: 20 }}></i>
                <div style={{ fontSize: 18, fontWeight: 600, color: '#005c53' }}>Mudar senha</div>
              </div>
              <div style={{ color: '#333', marginBottom: 12 }}>
                A nova senha deve ter pelo menos 6 caracteres
                <div style={{ marginTop: 6, color: '#666', fontSize: 13 }}>Após a confirmação você vai ser desconectado e redirecionado para a tela de login!</div>
              </div>
              <input
                type="password"
                placeholder="Nova senha"
                value={newPassword}
                onChange={e => { setNewPassword(e.target.value); if (pwError) setPwError(''); }}
                style={{
                  width: '100%',
                  padding: 12,
                  fontSize: 16,
                  border: '1px solid #ddd',
                  borderRadius: 8,
                  outline: 'none',
                  background: 'white',
                  marginBottom: 8,
                }}
              />
              {pwError && <div style={{ color: 'crimson', marginBottom: 8 }}>{pwError}</div>}
              <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                <button onClick={() => { setChangePwOpen(false); setNewPassword(''); setPwError(''); }} style={{ padding: '8px 20px', borderRadius: 8, border: 'none', background: '#ccc', color: '#222', fontWeight: 500, cursor: 'pointer' }}>Cancelar</button>
                <button
                  onClick={() => {
                    if (!newPassword || newPassword.length < 6) { setPwError('A senha deve ter ao menos 6 caracteres'); return; }
                    // aqui você pode chamar API para alterar senha
                    logout();
                    setChangePwOpen(false);
                    setTimeout(() => {
                      navigate('/');
                    }, 300);
                  }}
                  style={{ padding: '8px 20px', borderRadius: 8, border: 'none', background: '#005c53', color: '#fff', fontWeight: 700, cursor: 'pointer' }}
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Editarperfil;